WiseMetering.Views.CircuitEdit = WiseMetering.Views.Modal.Save.extend({
    template: 'templates/circuits/edit',
    form_prefix: 'circuit',
    title: () => i18next.t('modal.title.circuits.edit'),
    className: 'mbx-info text-left',
    width: 470,
    ui: {
        actuator: '#circuit-actuator',
        tag: 'select#circuit-tag'
    },

    serializeData: function() {
        let json = this.model.toJSON();
        json.hasActuators = this.model.site().hasActuators();
        return json;
    },

    onRender: function() {
        const usedActuatorIds = WiseMetering.circuits.pluck('actuator_id').filter(id => id !== this.model.get('actuator_id'));
        const actuators = [];

        WiseMetering.actuators.each(function(actuator) {
            if (!usedActuatorIds.includes(actuator.id) && this.model.get('site_id') === actuator.get('site_id')) {
                actuators.push(actuator);
            }
        }.bind(this));

        const circuitTags = WiseMetering.circuitTags.where({ system_category_id: this.model.get('system_category_id') });

        this.ui.tag.html(WiseMetering.utils.optionsFromModels(circuitTags, 'name', this.model.get('tag_id')));
        this.ui.actuator.append(WiseMetering.utils.optionsFromModels(actuators, 'name', this.model.get('actuator_id')));
    }
});
